import { createFileRoute } from '@tanstack/react-router'

import { validateTransactionsSearch } from '#pages/UserTransactions/search'

export const Route = createFileRoute('/_authenticated/companies_/$companyId/users_/$userId/transactions')({
  validateSearch: validateTransactionsSearch,
})
